































import { defineComponent, computed } from '@vue/composition-api';
import { Popup } from 'vant';

import { OCRModeEnum } from '@/shared/tools/ocr/enum';

export default defineComponent({
  components: {
    Popup,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    cardType: {
      type: String,
      default: OCRModeEnum.FRONT,
    },
  },
  emits: ['input', 'confirm'],
  setup(props, context) {
    const showDialog = computed(() => props.value);
    const promptMessage = computed(() => (props.cardType === OCRModeEnum.FRONT ? '确定删除人像面？' : '确定删除国徽面？'));

    const onClose = () => {
      context.emit('input', false);
    };

    const onConfirm = () => {
      context.emit('confirm', props.cardType);
    };

    return {
      showDialog,
      promptMessage,

      onClose,
      onConfirm,
    };
  },
});

